/**
 * Rotas públicas do cardápio online.
 * Painel interno de pedidos permanece em `/dashboard/orders`.
 */

export function catalogBasePath(companyKey: string): string {
  const key = String(companyKey || "").trim();
  return `/catalog/${encodeURIComponent(key)}`;
}

export function catalogConfirmationPath(companyKey: string): string {
  return `${catalogBasePath(companyKey)}/confirmation`;
}

export function catalogOrderStatusPath(companyKey: string): string {
  return `${catalogBasePath(companyKey)}/status-pedido`;
}

/** URL absoluta do cardápio (link público da loja). */
export function publicCatalogUrl(origin: string, companyKey: string): string {
  const base = (origin || "").replace(/\/$/, "");
  return `${base}${catalogBasePath(companyKey)}`;
}
